export default __webpack_public_path__ + "static/media/logo-dark.7a45e684.svg";